import { render, staticRenderFns } from "./Lenses.vue?vue&type=template&id=3a6838c6&scoped=true"
import script from "./Lenses.vue?vue&type=script&lang=js"
export * from "./Lenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6838c6",
  null
  
)

export default component.exports